import { combineReducers } from 'redux';
import { firestoreReducer } from 'redux-firestore';
import { firebaseReducer } from 'react-redux-firebase';
import authReducer from '../auth/authReducer';
import projectReducer from '../project/projectReducer';
import domainReducer from '../domain/domainReducer';
// import courseReducer from '../course/courseReducer';
import apiReducer from "../api/apiReducer";


const rootReducer = combineReducers({
    firesotre: firestoreReducer,
    firebase: firebaseReducer,
    auth: authReducer,
    project: projectReducer,
    domain: domainReducer,
    // course: courseReducer,
    api: apiReducer,
})

export default rootReducer;